<template>
  <article>
    <section
      class="tabs content-wrapper"
      :class="{
        'utility-hidden': enableSupplierFocusedSearch,
      }"
    >
      <ul>
        <li v-for="(tab, index) in tabs" :key="index">
          <button
            role="tab"
            class="tabs-nav-item"
            :class="{
              'is-active': tab.isActive,
              'is-tab2': tab.isTab2,
            }"
            @click="selectTab(tab)"
          >
            {{ tab.name }}
          </button>
        </li>
      </ul>
    </section>
    <section class="tabs-details">
      <slot></slot>
    </section>
  </article>
</template>

<script>
import Vue from "vue";

export default Vue.component("Tabs", {
  created() {
    this.tabs = this.$children;
  },
  data: () => {
    return {
      tabs: [],
    };
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name === selectedTab.name;
      });
    },
  },
  props: {
    isTab2: Boolean,
    enableSupplierFocusedSearch: Boolean,
  },
});
</script>
